import { render, staticRenderFns } from "./TemplateApplier.vue?vue&type=template&id=018bec0c&scoped=true&"
import script from "./TemplateApplier.vue?vue&type=script&lang=js&"
export * from "./TemplateApplier.vue?vue&type=script&lang=js&"
import style0 from "./TemplateApplier.vue?vue&type=style&index=0&id=018bec0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018bec0c",
  null
  
)

export default component.exports